/**
 * Path to Reception App with scanner debug + a prefilled Check-in QR field.
 * Prefixed with `/c/:clientId` (admin-web client scope).
 */
export const buildReceptionAppDebugCheckinPath = (clientId: string, checkinQr: string): string => {
  const trimmedClientId = clientId.trim()
  const trimmedQr = checkinQr.trim()
  if (!trimmedClientId || !trimmedQr) {
    throw new Error('clientId and checkinQr are required')
  }

  const params = new URLSearchParams({
    fullscreen: '1',
    scannerDebug: '1',
    debugQr: trimmedQr
  })

  return `/c/${encodeURIComponent(trimmedClientId)}/reception-app?${params.toString()}`
}
